import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { UUID } from '@/types';
import { csrfToken } from '@/util/helpers/ajax-helpers';

export type TExceededSubscription = {
  id: UUID;
  email: string;
  datasourceId: UUID;
  datasourceName: string;
  disabled?: Date;
  limited: boolean;
  usedCredits: number;
};

export const subscriptionManagementApi = createApi({
  reducerPath: 'subscriptionManagementApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/',
    credentials: 'same-origin',
    prepareHeaders: (headers) => {
      headers.set('Content-Type', 'application/json;charset=UTF-8');
      headers.set('x-requested-with', 'XMLHttpRequest');

      const token = csrfToken();
      if (token) headers.set('x-csrf-token', token);

      return headers;
    },
  }),
  tagTypes: ['ExceededSubscriptions'],
  endpoints: (builder) => ({
    getExceededSubscriptions: builder.query<TExceededSubscription[], void>({
      query: () => `admin/get-exceeded-subscriptions`,
      providesTags: ['ExceededSubscriptions'],
    }),
    updateSubscriptionLimitStatus: builder.mutation<
      void,
      { subscriptionId: UUID; status: boolean }
    >({
      query(request: { subscriptionId: UUID; status: boolean }) {
        return {
          url: `/admin/${request.subscriptionId}/change-limit-status`,
          method: 'POST',
          body: request.status,
        };
      },
      invalidatesTags: ['ExceededSubscriptions'],
    }),
  }),
});

export const {
  useGetExceededSubscriptionsQuery,
  useUpdateSubscriptionLimitStatusMutation,
} = subscriptionManagementApi;
